import { render } from "./AppLayout.vue?vue&type=template&id=073c6974"
import script from "./AppLayout.vue?vue&type=script&lang=js"
export * from "./AppLayout.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/clients-dev.printpigeons.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__